import CCColors from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flexDirection: 'row'},
  left: {flex: 0.2, padding: 20},
  center: {flex: 0.5},
  right: {flex: 0.3, padding: 10},
  scrollContainer: {
    flex: 1,
  },
  addNewBox: {
    width: '100%',
    padding: 10,
    borderRadius: 8,
    borderWidth: 1.5,
    borderStyle: 'dashed',
    borderColor: 'rgba(38,35,34,0.16)',
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 6,
  },
  participantsName: {
    paddingVertical: 10,
    paddingHorizontal: 14,
    paddingRight: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderLeftWidth: 3,
    borderLeftColor: 'transparent',
  },
  selectedName: {
    backgroundColor: '#EEF9F7',
    borderLeftColor: '#3DAB9E',
  },
  stickyButtonWrapper: {
    padding: 14,
    paddingTop: 10,
    backgroundColor: CCColors?.White,
    borderTopWidth: 1,
    borderTopColor: 'rgba(38,35,34,0.1)',
  },
});
